import React from 'react';
import SelectInputBase from '../base/SelectInputBase';

interface ISelectInputProps {
    label?: string;
    placeholder?: string;
    options?: { id: string | number; name: string }[];
    selectedOption?: { id: string | number; name: string };
    // TODO: May need to expose as a function as well to provide addtn'l functionality
    idField?: string;
    nameField?: string;
    // tslint:disable-next-line
    onChange?: (id: string | number) => void;
    value?: string | number;
    style?: React.CSSProperties;
    isCreatable?: boolean;
}

const SelectInput: React.FC<ISelectInputProps> = (props) => {
    return (
        <>
            <SelectInputBase {...props} />
        </>
    );
};

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/controls/forms/common/SelectInput.tsx